import { isInstitutionalConceptsResponse, isInstitutionalConceptResponse, } from '@urbanik/api-contracts';
export class InstitutionalConceptApiError extends Error {
    status;
    constructor(status) {
        super(status === 403
            ? 'No tienes acceso a esta entidad.'
            : status === 409
                ? 'El concepto cambió; actualiza antes de continuar.'
                : 'No se pudo completar la operación.');
        this.status = status;
    }
}
async function call(base, org, path, method = 'GET', body, signal) {
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(org))
        throw new InstitutionalConceptApiError(400);
    let response;
    try {
        response = await fetch(base.replace(/\/$/, '') +
            '/identity/multi-review/organizations/' +
            encodeURIComponent(org) +
            '/governance/concepts' +
            path, {
            method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Urbanik-Review': '1',
            },
            ...(body ? { body: JSON.stringify(body) } : {}),
            signal: signal ?? null,
        });
    }
    catch (error) {
        if (signal?.aborted)
            throw error;
        throw new InstitutionalConceptApiError(503);
    }
    if (!response.ok)
        throw new InstitutionalConceptApiError(response.status);
    try {
        return await response.json();
    }
    catch {
        throw new InstitutionalConceptApiError(502);
    }
}
export async function getInstitutionalConcepts(base, organizationId, signal) {
    const data = await call(base, organizationId, '', 'GET', undefined, signal);
    if (!isInstitutionalConceptsResponse(data, organizationId))
        throw new InstitutionalConceptApiError(502);
    return data;
}
export async function getInstitutionalConcept(base, organizationId, id, signal) {
    const data = await call(base, organizationId, '/' + encodeURIComponent(id), 'GET', undefined, signal);
    if (!isInstitutionalConceptResponse(data, organizationId) || data.concept.id !== id)
        throw new InstitutionalConceptApiError(502);
    return data;
}
export async function createInstitutionalConcept(base, organizationId, input) {
    const data = await call(base, organizationId, '', 'POST', input);
    if (!isInstitutionalConceptResponse(data, organizationId))
        throw new InstitutionalConceptApiError(502);
    return data;
}
export async function updateInstitutionalConcept(base, organizationId, id, input) {
    const data = await call(base, organizationId, '/' + encodeURIComponent(id), 'PATCH', input);
    if (!isInstitutionalConceptResponse(data, organizationId) || data.concept.id !== id)
        throw new InstitutionalConceptApiError(502);
    return data;
}
export async function setInstitutionalConceptActive(base, organizationId, id, active, expectedVersion) {
    const data = await call(base, organizationId, '/' + encodeURIComponent(id) + '/status', 'POST', {
        active,
        expectedVersion,
    });
    if (!isInstitutionalConceptResponse(data, organizationId) || data.concept.id !== id)
        throw new InstitutionalConceptApiError(502);
    return data;
}
